import { Link } from 'react-router-dom';
import { useBrand } from '../lib/brand';
import { MarketingShell, usePageMeta } from '../marketing/chrome';

export default function Privacy() {
  const brand = useBrand();
  usePageMeta(`Privacy · ${brand.name}`, `How ${brand.name} handles personal information.`);

  return (
    <MarketingShell>
      <article className="mx-auto max-w-copy px-6 py-mkt-sm md:py-mkt">
        <h1 className="text-mkt-section-sm md:text-mkt-section">Privacy Policy</h1>
        <p className="mt-3 text-mkt-body text-mkt-secondary">Last updated: 26 May 2026</p>

        <div className="mt-10 space-y-8 text-mkt-body">
          <p>
            This policy explains how {brand.name} collects, uses, stores, and protects personal information.
            We build for New Zealand clubs and design around the NZ Privacy Act 2020.
          </p>

          <section>
            <h2 className="text-[28px] font-semibold tracking-tight">What we collect</h2>
            <ul className="mt-3 list-disc space-y-2 pl-5 text-mkt-secondary">
              <li>Account details (email address, name, role)</li>
              <li>Club operations data (sessions, squads, attendance, meets)</li>
              <li>Communications content you create in the product</li>
            </ul>
          </section>

          <section>
            <h2 className="text-[28px] font-semibold tracking-tight">Sensitive information</h2>
            <p className="mt-3 text-mkt-secondary">
              Health and safety notes are stored separately from the person record. Each note has a short
              reader list. A linked guardian, or a swimmer aged 16 or over, authorises the note. People who
              are not on that list do not see the note.
            </p>
          </section>

          <section>
            <h2 className="text-[28px] font-semibold tracking-tight">How we use information</h2>
            <ul className="mt-3 list-disc space-y-2 pl-5 text-mkt-secondary">
              <li>To provide the product and operate club workflows you enable</li>
              <li>To support you (bug fixes, troubleshooting, responding to requests)</li>
              <li>To improve product performance and reliability</li>
            </ul>
          </section>

          <section>
            <h2 className="text-[28px] font-semibold tracking-tight">Sharing</h2>
            <p className="mt-3 text-mkt-secondary">
              We do not sell personal information. We only share information with service providers needed to
              run the product (for example hosting, email delivery), and only to the extent required.
            </p>
          </section>

          <section>
            <h2 className="text-[28px] font-semibold tracking-tight">Retention</h2>
            <p className="mt-3 text-mkt-secondary">
              Clubs control their data. Data is retained for as long as your club uses the service, subject to
              your instructions and legal requirements.
            </p>
          </section>

          <section>
            <h2 className="text-[28px] font-semibold tracking-tight">Access and corrections</h2>
            <p className="mt-3 text-mkt-secondary">
              If you want to access or correct personal information, contact us and we will help. For club member
              data, requests may be handled through your club administrators.
            </p>
          </section>

          <section>
            <h2 className="text-[28px] font-semibold tracking-tight">Contact</h2>
            <p className="mt-3 text-mkt-secondary">
              Use the <Link to="/contact" className="text-mkt-accent">contact form</Link>. You can also email{' '}
              <a className="text-mkt-accent" href={`mailto:${brand.email.support}`}>
                {brand.email.support}
              </a>
              .
            </p>
          </section>
        </div>
      </article>
    </MarketingShell>
  );
}
